import SchoolIcon from "@mui/icons-material/School";
import permissions from "app/permissions";
import { PREPARATORY_SCHEDULES, StudentServicePath } from "utils/constants";
import ListPreparatorySchedules from "./List";
import CreatePreparatorySchedule from "./Create";
import EditPreparatorySchedule from "./Edit";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: StudentServicePath + PREPARATORY_SCHEDULES,
  title: "Разписания подготвителна година",
  list: <ListPreparatorySchedules />,
  create: <CreatePreparatorySchedule />,
  edit: <EditPreparatorySchedule />,
  createPermission: permissions.canManagePreparatorySchedules,
  editPermission: permissions.canManagePreparatorySchedules,
  permission: permissions.canPreviewPreparatorySchedules,
};
